export class UnauthorizedError extends Error {
  constructor() {
    super("Usuário não autenticado!");
    this.name = "UnauthorizedError";
  }
}
